class EventMarker{

    iconDefault(ev){

        return {
            url: window.host + "/uploads/static/events/category/markers/" + ev.category.id + ".png",
            scaledSize: new google.maps.Size(36, 36),
            borderColor: "#137333",
        };

    }

    createMarker(ev){

        return new google.maps.Marker({
            position: ev.location.coordinates,
            icon: this.iconDefault(ev),
        });

    }

}

export default EventMarker;